const API_URL = process.env.REACT_APP_API_URL + "/api";

export const getCrewMembers = async (requestParams) => {
  let bodyRequestParams = {}
  const apiUrl = `${API_URL}/admin/get-crew-members`
  for (const [key, value] of Object.entries(requestParams)) {
    if (value) {
      bodyRequestParams[key] = value
    }
  }

  const response = await fetch(apiUrl, {
    method: "POST",
    body: JSON.stringify(bodyRequestParams),
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  if (!response.ok) {
    let error = await response.json()
    throw new Error(error.message)
  }

  return response.json()
}

export const postAssignTask = async (requestParams, token) => {
  let bodyRequestParams = {}
  const apiUrl = `${API_URL}/admin/assign_task`
  for (const [key, value] of Object.entries(requestParams)) {
    if (value) {
      bodyRequestParams[key] = value
    }
  }

  const response = await fetch(apiUrl, {
    method: "POST",
    body: JSON.stringify(bodyRequestParams),
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  })

  if (!response.ok) {
    let error = await response.json()
    throw new Error(error.message)
  }

  return response.json()
}

export const postCreateCrewMember = async (requestParamsOrFormData) => {
  const apiUrl = `${API_URL}/admin/create-crew-member`

  const isFormData =
    typeof FormData !== "undefined" &&
    requestParamsOrFormData instanceof FormData

  let body
  const headers = { "Accept": "application/json" }

  if (isFormData) {
    body = requestParamsOrFormData
  } else {
    let bodyRequestParams = {}
    for (const [key, value] of Object.entries(requestParamsOrFormData || {})) {
      if (value !== undefined && value !== null && value !== "") {
      bodyRequestParams[key] = value
    }
    }
    body = JSON.stringify(bodyRequestParams)
    headers["Content-Type"] = "application/json"
  }

  const response = await fetch(apiUrl, {
    method: "POST",
    body,
    headers,
  })

  if (!response.ok) {
    let error = await response.json().catch(() => ({}))
    throw new Error(error.message || "Failed to create crew member")
  }

  return response.json()
}
